// extracted by mini-css-extract-plugin
export default {"mediaAssetsContainer":"_2_j6f___Images-module__mediaAssetsContainer","galleryContainer":"_3jTi0___Images-module__galleryContainer"};